<template>
  <div class="absolute inset-0 overflow-hidden flex flex-col-reverse items-center">
    <div id="text" class="absolute -left-px -right-px bottom-0 flex flex-col-reverse pb-10">
      <title-description-block/>
    </div>
  </div>
</template>

<script>
import TitleDescriptionBlock from "../TitleDescriptionBlock";

export default {
  name: "GradientLayer",
  components: {TitleDescriptionBlock}
}
</script>

<style lang="scss" scoped>
* {
  pointer-events: none;
}

#text {
  padding-top: 100px;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 0, #fff), linear-gradient(180deg, hsla(0, 0%, 100%, 0) 0, #fff);
}
</style>